import * as THREE from "three";
import Experience from "./Experience.js";
import { PointerLockControls } from "./Utils/PointerLockControls.js";

export default class Camera {
  constructor() {
    this.experience = new Experience();
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;

    this.setInstance();
    this.setControls();
  }

  setInstance() {
    this.instance = new THREE.PerspectiveCamera(
      35,
      this.sizes.width / this.sizes.height,
      0.1,
      1000
    );
    this.instance.position.set(0.45, 0.25, 1);

    // this.instance.position.set(0, 0.25, 6);
    // this.instance.lookAt(0, -0.50, 0);

    // this.instance.position.set(0, 0, 100);
    // this.instance.lookAt(0, 0, 0);

    this.instance.rotation.order = "YXZ";
    this.instance.lookAt(0.35, -0.35, 0.2);
    this.scene.add(this.instance);
  }

  setControls() {
    this.controls = new PointerLockControls(this.instance, this.canvas);
    this.controls.maxPolarAngle = Math.PI;
    this.controls.enableDamping = true;

    this.canvas.addEventListener("mousedown", () => {
      this.controls.lock();
    });

    this.canvas.addEventListener("mouseup", () => {
      this.controls.unlock();
    });

    this.scene.add(this.controls.getObject());
  }

  resize() {
    
    this.instance.aspect = this.sizes.width / this.sizes.height;
    this.instance.updateProjectionMatrix();
  }

  update() {

    // console.log(this.controls.getObject().position);


    if (this.instance.rotation.y > Math.PI * 0.55) {
      this.instance.rotation.y = Math.PI * 0.55;
    }

    if (this.instance.rotation.y < -Math.PI * 0.5) {
      this.instance.rotation.y = -Math.PI * 0.5;
    }
  }
}
